import "./style.scss";
import {BsFillQuestionCircleFill} from "react-icons/bs";
import {Tooltip} from "react-tooltip";

const UseTooltip = (props) => {
  const {
    title,
    id
  } = props;
  return (
    <>
      <button className='tooltip-button' id={id}><BsFillQuestionCircleFill/></button>
      <Tooltip anchorSelect={`#${id}`} content={title}/>
    </>
  )
}

export default UseTooltip;